import getJupyterURL from './getJupyterURL';

export default getJupyterURL;
